import {
  AssigmentExecutionZod,
  AssigmentPlanZod,
  AssignmentCostsZod,
  AssignmentZod,
  CarManufacturerZod,
  ChannelEveningZod,
  ChannelMessageDeletionZod,
  ChannelMessageZod,
  ChannelZod,
  ConfigurationZod,
  DashboardAlertZod,
  DistanceZod,
  JudicialPreanalysisZod,
  JudicialRecordZod,
  MessageZod,
  MilestoneZod,
  NotificationZod,
  OrganizationZod,
  PiloteCentralZod,
  PiloteOrganizationZod,
  PiloteTeamZod,
  PiloteTransportRequestZod,
  PiloteUserAccountZod,
  PiloteUserZod,
  PiloteVolunteerZod,
  PromotionTrackingZod,
  PromotionZod,
  RegionInfoZod,
  RegionZod,
  RegistrationEventZod,
  RegistrationZod,
  SupportRequestAgentZod,
  SupportRequestItemZod,
  SupportRequestZod,
  TeamEventZod,
  TeamLocationZod,
  TeamZod,
  TermsOfUseZod,
  TransportRequestEventZod,
  TransportRequestTeamLocationZod,
  TransportRequestZod,
  UserTokensZod,
  UserZod,
  VolunteerZod,
} from '@onr/schema'
import { firestoreDataConverter, ZodSchemaError } from '@valian/react-kitchen-sink'
import { collectionsBuilder } from 'zod-firebase'

export const schema = {
  carManufacturers: {
    zod: CarManufacturerZod,
    readonlyDocuments: true,
  },
  configurations: {
    zod: ConfigurationZod,
    includeDocumentIdForZod: true,
  },
  notifications: {
    zod: NotificationZod,
  },
  regions: {
    zod: RegionZod,
    yapla: { zod: RegionInfoZod, singleDocumentKey: 'yapla' },
    pilote: { zod: PiloteCentralZod, singleDocumentKey: 'pilote' },
    channels: {
      zod: ChannelZod,
      evenings: {
        zod: ChannelEveningZod,
        messages: { zod: ChannelMessageZod },
        deletions: { zod: ChannelMessageDeletionZod },
      },
    },
  },
  teams: {
    zod: TeamZod,
    pilote: { zod: PiloteTeamZod, singleDocumentKey: 'pilote' },
    events: { zod: TeamEventZod },
    locations: { zod: TeamLocationZod },
    messages: { zod: MessageZod },
  },
  volunteers: {
    zod: VolunteerZod,
    pilote: { zod: PiloteVolunteerZod, singleDocumentKey: 'pilote' },
    milestones: { zod: MilestoneZod },
  },
  judicialRecords: {
    zod: JudicialRecordZod,
  },
  judicialPreanalyses: {
    zod: JudicialPreanalysisZod,
  },
  termsOfUse: {
    zod: TermsOfUseZod,
    singleDocumentKey: 'termsOfUse',
  },
  transportRequests: {
    zod: TransportRequestZod,
    pilote: { zod: PiloteTransportRequestZod, singleDocumentKey: 'pilote' },
    events: { zod: TransportRequestEventZod },
    teamLocation: { zod: TransportRequestTeamLocationZod, singleDocumentKey: 'partner' },
  },
  assignments: {
    zod: AssignmentZod,
    readonlyDocuments: true,
    costs: { zod: AssignmentCostsZod, singleDocumentKey: 'costs', readonlyDocuments: true },
    plans: { zod: AssigmentPlanZod, readonlyDocuments: true },
    executions: { zod: AssigmentExecutionZod, readonlyDocuments: true },
  },
  distances: {
    zod: DistanceZod,
    readonlyDocuments: true,
  },
  users: {
    zod: UserZod,
    tokens: {
      zod: UserTokensZod,
      singleDocumentKey: 'tokens',
    },
    pilote: {
      zod: PiloteUserZod,
      singleDocumentKey: 'pilote',
    },
  },
  organizations: {
    zod: OrganizationZod,
    pilote: {
      zod: PiloteOrganizationZod,
      singleDocumentKey: 'pilote',
    },
  },
  registrations: {
    zod: RegistrationZod,
    events: { zod: RegistrationEventZod },
  },
  dashboardAlerts: {
    zod: DashboardAlertZod,
  },
  promotions: {
    zod: PromotionZod,
  },
  promotionTracking: {
    zod: PromotionTrackingZod,
  },
  supportRequests: {
    zod: SupportRequestZod,
    agent: { zod: SupportRequestAgentZod, singleDocumentKey: 'agent' },
    items: { zod: SupportRequestItemZod },
  },
  piloteUsers: {
    zod: PiloteUserAccountZod,
  },
} as const

export const collections = collectionsBuilder(schema, {
  zodErrorHandler: (error, snapshot) => {
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.error('ZodError', error)
    }

    return new ZodSchemaError(snapshot, { cause: error })
  },
  snapshotDataConverter: firestoreDataConverter,
})
